import Dashboard from '../../spa/dashboard/cadeia/DashBoard';

export default {
  path: 'dashboard',
  name: 'dashboard',
  component: Dashboard,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/dashboard.js